export default "__VITE_ASSET__CNpCD1OO__"